const SquareExclamatioMark = () => {
  return (
    <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.5 7.49996V4.12498M7.5 10.0015V10.0312M14.25 3.28124L14.25 11.7188C14.25 13.1167 13.1167 14.25 11.7187 14.25H3.28125C1.88328 14.25 0.75 13.1167 0.75 11.7188V3.28124C0.75 1.88327 1.88328 0.75 3.28125 0.75H11.7188C13.1167 0.75 14.25 1.88327 14.25 3.28124Z'
        stroke='#6B6B6B'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default SquareExclamatioMark;
